import './RainfallTable.css';
import { useStations } from '../../hooks/useStations';
import { StationsError } from './stations-error';
import { SkeletonRainfallTable } from './skeleton-rainfall-table';
import { Table } from './table';

export function RainfallTable() {
  const { stations, stationsLoading, stationsError } = useStations();

  if (stationsError) return <StationsError />;

  return stationsLoading ? (
    <SkeletonRainfallTable />
  ) : (
    <>{stations.length > 0 && <Table stations={stations} />}</>
  );
}
